module.exports = __webpack_public_path__ + "experience/innovation/models/drone-rotor.7d51439.obj";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/drone-rotor.obj
// module id = 5S31
// module chunks = 1